import { Component, Input, OnInit } from '@angular/core';
import { Modal } from 'src/app/models';
import { GoogleService } from 'src/app/services';

@Component({
    selector: 'app-video-player',
    templateUrl: './video-player.component.html',
    styleUrls: ['./video-player.component.scss']
})
export class VideoPlayerComponent implements OnInit {
    @Input() data: Modal;
    @Input() path: string;

    public video: string = '';
    public poster: string = '';

    constructor(
        private googleSvc: GoogleService
    ) { }

    ngOnInit(): void {
        if (!this.data.video.includes('http')) {
            this.video = this.path + this.data?.video;
        }

        if (!this.data.poster.includes('http')) {
            this.poster = this.path + this.data?.poster;
        }

        console.log(this.data);

        this.googleSvc.sendGAEventById(5, { category: this.data.id, label: this.data.video });
    }

    public ignoreVideoClick(e): void {
        e.preventDefault();
    }
}
